import React, { Component } from 'react';
import { withTranslation } from 'react-i18next'
import { Route, Switch, Redirect, withRouter } from 'react-router-dom'
import { Helmet } from 'react-helmet';
import i18n from 'cityads-v3/i18n';

import Balaclava from 'cityads-v3/components/Balaclava';

import Me from './Me';
import Accounts from '../payments/Accounts';
import Credits from './Credits';
import Manager from './Manager';

import classes from './Profile.scss';

export const PROFILE_ME = 'PROFILE_ME';
export const PROFILE_ACCOUNTS = 'PROFILE_ACCOUNTS';
export const PROFILE_CREDITS = 'PROFILE_CREDITS';
export const PROFILE_MANAGER = 'PROFILE_MANAGER';

function WrapComponent(Component, menuValue) {
  return ({ title, ...rest }) => (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Balaclava
        menuValue = {menuValue}
      />

      <Component {...rest} />
    </>
  );
}

const MeWrapper = WrapComponent(Me, PROFILE_ME);
const AccountsWrapper = WrapComponent(Accounts, PROFILE_ACCOUNTS);
const CreditsWrapper = WrapComponent(Credits, PROFILE_CREDITS);
const ManagerWrapper = WrapComponent(Manager, PROFILE_MANAGER);

@withRouter
@withTranslation(['main'], { i18n, wait: false })
export default class Profile extends Component {

  render() {
    const { t } = this.props;

    return (
      <>
        <Helmet>
          <title>{t('profile.me')}</title>
        </Helmet>

        <Balaclava
          menuShow = {true}
          menu={[
            {
              id: PROFILE_ME,
              title: t('profile.me'),
              route: '/publisher/profile/me',
            },
            {
              id: PROFILE_CREDITS,
              title: t('profile.credits'),
              route: '/publisher/profile/credits',
            },
            {
              id: PROFILE_MANAGER,
              title: t('profile.manager'),
              route: '/publisher/profile/manager',
            }
          ]}
        />

        <div className={classes.profileContainer}>
          <Switch>
            <Route path="/publisher/profile/me" exact strict render={props => <MeWrapper title={t('profile.me')} {...props} />} />
            <Route path="/publisher/profile/me" render={() => <Redirect to="/publisher/profile/me" />}/>

            <Route path="/publisher/profile/credits/currencies" exact strict render={props => <AccountsWrapper title={t('profile.credits')} {...props} />} />
            <Route path="/publisher/profile/credits/currencies" render={props => <Redirect to="/publisher/profile/credits/currencies" />} />

            <Route path="/publisher/profile/credits" exact strict render={props => <CreditsWrapper title={t('profile.credits')} {...props} />} />
            <Route path="/publisher/profile/credits" render={() => <Redirect to="/publisher/profile/credits" />}/>

            <Route path="/publisher/profile/manager" exact strict render={props => <ManagerWrapper title={t('profile.manager')} {...props} />} />
            <Route path="/publisher/profile/manager" render={() => <Redirect to="/publisher/profile/manager" />}/>

            <Route render={() => (
              <Redirect to="/publisher/profile/me" />
            )}/>
          </Switch>
        </div>
      </>
    );
  }

}
